module.exports = __webpack_public_path__ + "img/vertical_6_4_9005.eda2bb9c.png";